import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { get } from 'lodash'
import React, { ReactElement } from 'react'
import { Query_Root } from 'src/@types/graphql'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { useUserLocale } from 'src/user/UserContext'
import { HtmlRenderer } from 'src/shared/presentation/HtmlRenderer'

interface Props {
  groupTitle: string
  groupAvgRating?: number
  mode: 'view' | 'edit'
  rows: Query_Root['criteria_config']
  EditControl: React.FC<any>
  resolveControlProps: (row: any) => any
}

export const CriteriaConfigTable = ({
  groupTitle,
  groupAvgRating,
  rows,
  mode = 'view',
  EditControl,
  resolveControlProps,
}: Props): ReactElement => {
  const { getMessage } = useMessageSource()
  const language = useUserLocale()

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
        <HtmlRenderer html={groupTitle} variant={'h3'} color={'textSecondary'} />

        {groupAvgRating !== undefined && groupAvgRating !== 0 && (
          <Typography variant="body1" fontWeight={'lighter'} color="textSecondary">
            {`${getMessage('label.average')}: ${groupAvgRating}`}
          </Typography>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table style={{ overflow: 'wrap' }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ width: '10%' }}>
                {getMessage('label.criteria')}
              </TableCell>
              <TableCell sx={{ width: '75%' }}>{getMessage('label.question')}</TableCell>
              <TableCell align="center" sx={{ width: '15%' }}>
                {getMessage('label.rating')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((item) => (
              <TableRow key={item.id.toString()}>
                <TableCell align="center">
                  <Typography variant="subtitle2">{item.criteria_id}</Typography>
                </TableCell>
                <TableCell>
                  <HtmlRenderer html={get(item.description, language, '')} />
                </TableCell>
                <TableCell align="center" sx={{ lineHeight: '100%' }}>
                  {resolveControlProps(item).hide || (
                    <EditControl disabled={mode === 'view'} {...resolveControlProps(item)} />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
